<template>
	<a :href="href" class="schedule_link">
		<dl class="box_schedule" :style="style">
			<dt><span class="inner_tit" v-html="time"></span></dt>
			<dd>
				<img v-if="schedule.image" :src="thumbnail" class="thumb_g" width="45" height="45" alt="썸네일 이미지">
				<div :class="descClass">
					<strong class="tit_subject">{{schedule.title}}</strong>
					<p><em>{{schedule.category.name}}</em>{{schedule.description}}</p>
				</div>
			</dd>
		</dl>
	</a>
</template>

<script>
	import { parseISO } from 'date-fns';

	import {getIconText} from '@src/schedule/common';
	import {getThumbnailUrl} from '@src/utils';

	export default {
		props: ['schedule', 'date'],
		computed: {
			href() {
				return `/${CAFEAPP.GRPCODE}/${CAFEAPP.FLDID}/${this.date}/_schedule/#schedule-${this.schedule.scheduleId}`;
			},
			thumbnail() {
				return getThumbnailUrl(this.schedule.image, 90, 90, 'C');
			},

			style() {
				return {
					backgroundColor: this.schedule.category.color,
				};
			},
			time() {
				return getIconText(parseISO(this.date), this.schedule);
			},

			descClass() {
				return ['desc_info', this.schedule.description && this.schedule.description.length ? '' : 'empty_desc'];
			},
		},
	}
</script>
